class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.closeTimeout = null;

    // Handle clicks on summary
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    this.summary.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseReEnter.bind(this));
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));

    this.content.style.opacity = '0';
    this.content.style.transform = 'translateY(-10px)';
  }

  onSummaryClick(e) {
    e.preventDefault();
    
    const href = this.summary.getAttribute('data-href');
    
    // If clicking while menu is open, navigate to the link
    if (this.mainDetailsToggle.hasAttribute('open') && href) {
      window.location.href = href;
    }
    // Otherwise, let mouseenter handle opening
  }

  onMouseEnter() {
    // Close all other open details-disclosure elements
    document.querySelectorAll('details-disclosure').forEach((disclosure) => {
      if (disclosure !== this && disclosure.mainDetailsToggle.hasAttribute('open')) {
        disclosure.animateClose();
      }
    });

    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);

    this.content.animate(
      [
        { opacity: 0, transform: 'translateY(-10px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ],
      {
        duration: 200,
        easing: 'ease-in-out',
        fill: 'forwards'
      }
    );
  }

  onMouseLeave() {
    this.closeTimeout = setTimeout(() => {
      this.animateClose();
    }, 100);
  }

  onMouseReEnter() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.closeTimeout = setTimeout(() => {
          this.animateClose();
        }, 100);
      }
    });
  }

  animateClose() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    this.content.animate(
      [
        { opacity: 1, transform: 'translateY(0)' },
        { opacity: 0, transform: 'translateY(-10px)' }
      ],
      {
        duration: 200,
        easing: 'ease-in-out',
        fill: 'forwards'
      }
    ).onfinish = () => {
      this.mainDetailsToggle.removeAttribute('open');
      this.summary.setAttribute('aria-expanded', false);
    };
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onMouseEnter() {
    super.onMouseEnter();
    if (!this.header) return;
    this.header.preventHide = true;
    
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  onMouseLeave() {
    super.onMouseLeave();
    if (!this.header) return;
    this.header.preventHide = false;
  }

  onMouseReEnter() {
    super.onMouseReEnter();
    if (!this.header) return;
    this.header.preventHide = true;
  }
}

customElements.define('header-menu', HeaderMenu);